@if (leg.official === false) {
  <div class="units cs">
    <div class="unit-selections-2">
      @for (result of leg.selections | orderBy:'display_order' | slice:0:(leg.selections.length / 2) | reverse; track $index) {
        <div class="unit-item-2 cs">
          <div class="breakdown-score-2">
            <span [transloco]="'selections.' + result.name" [translocoParams]="{defaultValue: result.name}"></span>
          </div>
          <div class="breakdown-units-2">
            <span class="mr-0.5">{{getUnits(result.unit_distributions) | formatUnits }}</span>
            @if (getUnits(result.unit_distributions) != 0) {
              <span class="value" [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          </div>
        </div>
      }
    </div>
    <div class="unit-selections-2">
      @for (result of leg.selections | orderBy:'display_order' | slice:(leg.selections.length / 2); track $index) {
        <div class="unit-item-2 cs">
          <div class="breakdown-score-2">
            <span [transloco]="'selections.' + result.name" [translocoParams]="{defaultValue: result.name}"></span>
          </div>
          <div class="breakdown-units-2">
            <span class="mr-0.5">{{getUnits(result.unit_distributions) | formatUnits }}</span>
            @if (getUnits(result.unit_distributions) != 0) {
              <span class="value" [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
